var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"disabled":!_vm.downloadMenuAvailable,"text":""}},on),[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-download")]),_vm._v(" Download ")],1)]}}])},[_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.downloadableAssets),function(ref){
var url = ref.url;
var width = ref.width;
var height = ref.height;
return _c('v-list-item',{key:url,attrs:{"disabled":!url,"download":"","href":url}},[_c('v-list-item-title',{staticClass:"d-flex align-center"},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-download")]),_c('v-spacer'),_c('span',[_vm._v(_vm._s(width)+" x "+_vm._s(height))])],1)],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }